import { loadStripe } from "@stripe/stripe-js";

const publishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

// Resolve loader failures to null so a blocked Stripe.js request cannot become
// an unhandled rejection in the application.
export const stripePromise = publishableKey
  ? Promise.resolve()
      .then(() => loadStripe(publishableKey))
      .catch(() => null)
  : null;
